import React from 'react';
import ContentTable from '../components/ContentCategories/ContentTable';
const ContentCategories = () => {
    return ( <>
    <ContentTable/>
    </> );
}
 
export default ContentCategories;